import { Stack, Slider, Typography } from "@mui/material";
import { Controller, Control, FieldPath, FieldValues } from "react-hook-form";

interface FormSliderProps<T extends FieldValues> {
  name: FieldPath<T>;
  control: Control<T>;
  label: string;
  min: number;
  max: number;
  step?: number;
  unit?: string;
  valueLabelFormat?: (value: number, unit?: string) => string;
  required?: boolean;
}

export const FormSlider = <T extends FieldValues>({
  name,
  control,
  label,
  min,
  max,
  step = 1,
  unit = "",
  valueLabelFormat,
  required = false,
}: FormSliderProps<T>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div data-field={name}>
          <Typography id={`${name}-slider`} gutterBottom>
            {label}
          </Typography>
          <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
            <Slider
              {...field}
              min={min}
              max={max}
              step={step}
              valueLabelFormat={
                valueLabelFormat
                  ? (value) => valueLabelFormat(value, unit)
                  : undefined
              }
              valueLabelDisplay="auto"
              aria-labelledby={`${name}-slider`}
            />
            <Typography
              fontSize={32}
              fontWeight={"bold"}
              gutterBottom
              whiteSpace={"nowrap"}
            >
              {field.value} {unit}
            </Typography>
          </Stack>
          {error && (
            <Typography color="error" variant="caption">
              {error.message}
            </Typography>
          )}
        </div>
      )}
    />
  );
};
